// Libraries
import React from 'react';
import PropTypes from 'prop-types';

// Enums
import { ValidationTypes } from 'engagement/enums/singleTextBox';

// Components
import Textarea from 'common/components/Textarea';

const TextareaInput = (props) => {
  const { id, label, placeholder, value, validationType, characterCountMax, onChange } = props;

  const inputFormId = `input-${id}`;
  const showCharacterCount = validationType === ValidationTypes.CHARACTER_COUNT;

  return (
    <div className="field">
      <label className="label visuallyhidden" htmlFor={inputFormId}>
        {label}
      </label>
      <div className="control">
        <Textarea
          data-test="textarea"
          id={inputFormId}
          placeholder={placeholder}
          defaultValue={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
      {showCharacterCount && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
          }}
        >
          {`${value.length}/${characterCountMax}`}
        </div>
      )}
    </div>
  );
};

TextareaInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  validationType: PropTypes.string,
  characterCountMax: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

TextareaInput.defaultProps = {
  value: '',
  placeholder: '',
  label: '',
  validationType: '',
  characterCountMax: '',
};

export default TextareaInput;
